import { useGraphqlQuery } from "@harea/component"
import { TTimeOffsResponse } from "@harea/component";
import { DayOffListQuery } from "views/dayoff/queries/DayOffListQuery";

export const useDayOffListQuery = (suspense?: boolean, variables?: any) => {
    return useGraphqlQuery<DayOffListQuery, TTimeOffsResponse>(new DayOffListQuery(variables), {suspense});
}